var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{staticClass:"mb-1",attrs:{"cols":"12","lg":"7"}},[_c('levels-list')],1),_c('b-col',{attrs:{"cols":"12","lg":"5"}},[_c('locations-list')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }